import { Component, OnInit, Input } from '@angular/core';

import { I18NLanguageType, I18nService } from './i18n.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit {
  @Input() inNavbar = false;
  @Input() menuClass = '';

  constructor(private i18nService: I18nService) {}

  ngOnInit() {}

  setLanguage(language: I18NLanguageType) {
    this.i18nService.language = language;
  }

  get currentLanguage(): I18NLanguageType {
    return this.i18nService.language;
  }

  get languages(): I18NLanguageType[] {
    return this.i18nService.supportedLanguages;
  }
}
